import React, { useState, useCallback } from 'react';
// import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TabHeaderBlock from '../components/TabHeaderBlock';
import TabSidebarBlock from '../components/TabSidebarBlock';
import { CustomUploadFile } from '../styles/elements';
import { WhiteBlock } from '../styles/WhiteBlock';

const Branding = () => {
  const [customUrlInput, setcustomUrlInput] = useState(false);
  const customUrlInputclick = useCallback((value) => (e) => {
    if (e) e.preventDefault();
    setcustomUrlInput((state) => (state === value ? null : value));
  });
  return (
    <Layout>
      <SEO title="Branding" />
      <div className="db-area-main">
        <div className="db-container">
          <a href="#!" className="db-back-link button-chevron-left">
            <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
            dashboard
          </a>

          <h1 className="db-heading">
            Dribbble Workspace{' '}
            <img
              src="/img/chevron-down.svg"
              alt="chevron"
              style={{ width: 23, opacity: 0.4 }}
            />
          </h1>

          <TabHeaderBlock />
          <div className="db-tab-content-block">
            <div className="flex-row">
              <div className="col sidebar-col">
                <TabSidebarBlock />
              </div>

              <div className="col right-block-col">
                <WhiteBlock>
                  <h2 className="white-block-head">Branding</h2>

                  <div className="white-block-body">
                    <div className="flex-row">
                      <div className="col col-6">
                        <div className="form-group">
                          <label>Brand Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Brand Name"
                          />
                        </div>
                      </div>
                      <div className="col col-6">
                        <div className="form-group">
                          <label>Industry</label>
                          <select
                            className="form-control"
                            placeholder="Enter Publisher Name">
                            <option>Enterprenuer</option>
                          </select>
                        </div>
                      </div>
                      <div className="col col-6">
                        <CustomUploadFile className="form-group">
                          <label>Logo</label>
                          <div className="flex-row no-margin upload-file-input align-items-center">
                            <div className="img-placeholder">
                              <img
                                src="/img/image-placeholder.svg"
                                alt="logo"
                              />
                            </div>
                            <div className="flex-1">
                              <p style={{ marginBottom: 12 }}>
                                JPG or PNG Max size of 800k
                              </p>

                              <div className="flex-row no-margin position-relative">
                                <div className="position-relative">
                                  <input
                                    type="file"
                                    className="custom-file-upload-button"
                                  />
                                  <span className="button light-blue-button">
                                    Choose file
                                  </span>
                                </div>
                                <div>
                                  <button
                                    onClick={customUrlInputclick(0)}
                                    type="button"
                                    className={`link-button ${
                                      customUrlInput === 0 ? 'active' : ''
                                    }`}
                                    style={{
                                      minWidth: 40,
                                      margin: '10px 0 0 20px',
                                    }}>
                                    <svg
                                      className="link-img"
                                      width="24"
                                      height="24"
                                      fill="none"
                                      viewBox="0 0 24 24">
                                      <path
                                        stroke="#0E64FF"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.5"
                                        d="M3.27 12A5.46 5.46 0 012 8.5C2 5.48 4.47 3 7.5 3h5C15.52 3 18 5.48 18 8.5S15.53 14 12.5 14H10"
                                      />
                                      <path
                                        stroke="#0E64FF"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.5"
                                        d="M20.73 12A5.46 5.46 0 0122 15.5c0 3.02-2.47 5.5-5.5 5.5h-5C8.48 21 6 18.52 6 15.5S8.47 10 11.5 10H14"
                                      />
                                    </svg>
                                    <svg
                                      className="cross-img"
                                      width="20"
                                      height="21"
                                      fill="none"
                                      viewBox="0 0 20 21">
                                      <path
                                        stroke="#0E64FF"
                                        strokeLinecap="round"
                                        strokeWidth="1.636"
                                        d="M1 1.5l18 18M19 1.5l-18 18"
                                      />
                                    </svg>
                                  </button>
                                </div>

                                <div
                                  className={`url-input-box ${
                                    customUrlInput === 0 ? 'show' : ''
                                  }`}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter URL"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </CustomUploadFile>
                      </div>
                      <div className="col col-6">
                        <CustomUploadFile className="form-group">
                          <label>Favicon</label>
                          <div className="flex-row no-margin upload-file-input align-items-center">
                            <div className="img-placeholder">
                              <img
                                src="/img/image-placeholder.svg"
                                alt="logo"
                              />
                            </div>
                            <div className="flex-1">
                              <p style={{ marginBottom: 12 }}>
                                JPG or PNG Max size of 800k
                              </p>

                              <div className="flex-row no-margin position-relative">
                                <div className="position-relative">
                                  <input
                                    type="file"
                                    className="custom-file-upload-button"
                                  />
                                  <span className="button light-blue-button">
                                    Add icon
                                  </span>
                                </div>
                                <div>
                                  <button
                                    onClick={customUrlInputclick(1)}
                                    type="button"
                                    className={`link-button ${
                                      customUrlInput === 1 ? 'active' : ''
                                    }`}
                                    style={{
                                      minWidth: 40,
                                      margin: '10px 0 0 20px',
                                    }}>
                                    <svg
                                      className="link-img"
                                      width="24"
                                      height="24"
                                      fill="none"
                                      viewBox="0 0 24 24">
                                      <path
                                        stroke="#0E64FF"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.5"
                                        d="M3.27 12A5.46 5.46 0 012 8.5C2 5.48 4.47 3 7.5 3h5C15.52 3 18 5.48 18 8.5S15.53 14 12.5 14H10"
                                      />
                                      <path
                                        stroke="#0E64FF"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.5"
                                        d="M20.73 12A5.46 5.46 0 0122 15.5c0 3.02-2.47 5.5-5.5 5.5h-5C8.48 21 6 18.52 6 15.5S8.47 10 11.5 10H14"
                                      />
                                    </svg>
                                    <svg
                                      className="cross-img"
                                      width="20"
                                      height="21"
                                      fill="none"
                                      viewBox="0 0 20 21">
                                      <path
                                        stroke="#0E64FF"
                                        strokeLinecap="round"
                                        strokeWidth="1.636"
                                        d="M1 1.5l18 18M19 1.5l-18 18"
                                      />
                                    </svg>
                                  </button>
                                </div>

                                <div
                                  className={`url-input-box ${
                                    customUrlInput === 1 ? 'show' : ''
                                  }`}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter URL"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </CustomUploadFile>
                      </div>
                      <div className="col col-12">
                        <div className="brand-colors-block">
                          <div className="form-group">
                            <label>Brand Colors</label>

                            <div className="flex-row align-items-center no-margin">
                              <span
                                className="single-color-circle"
                                style={{ backgroundColor: '#FF7968' }}
                              />

                              <button
                                type="button"
                                className="single-color-circle add-color">
                                <svg
                                  width="13"
                                  height="13"
                                  fill="none"
                                  viewBox="0 0 13 13">
                                  <path
                                    fill="#000"
                                    d="M.531 6.86h5.266v5.265c0 .29.242.531.531.531.29 0 .531-.242.531-.531V6.859h5.274a.535.535 0 00.523-.53.535.535 0 00-.523-.532H6.859V.523A.535.535 0 006.33 0a.535.535 0 00-.532.523v5.274H.53A.537.537 0 000 6.328c0 .29.242.531.531.531z"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col flex-1">
                        <div className="text-right">
                          <button className="button" type="submit">
                            Save Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </WhiteBlock>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Branding;
